import React from 'react';
import Card from 'material-ui/Card/Card';
import Button from '@material-ui/core/Button';
import LibraryActions from 'actions/library/LibraryActions';
import LibraryCreateActions from 'actions/library/LibraryCreateActions';
import ConstValues from 'utils/const';
import LibraryCreateDialog from 'components/pure/library/LibraryCreateDialog';

/**
 * Search tab for the library page.
 * TODO Refactor, i refuse to believe this component can be this complex
 */
export default class LibraryBrowseTab extends React.Component {
  constructor(props) {
    super(props);
    this.onClickLibrary = this.onClickLibrary.bind(this);
    this.onClickMostCommonlyUsedTag = this.onClickMostCommonlyUsedTag.bind(this);
    this.onClickRecentlyUsedTag = this.onClickRecentlyUsedTag.bind(this);
    this.searchMostRecentlyAddedCalls = this.searchMostRecentlyAddedCalls.bind(this);
  }

  _searchTag(event) {
    const tag = event.target.dataset.tag;
    setTimeout(() => LibraryActions.searchTag(tag), 0);
  }

  onClickRecentlyUsedTag(event) {
    LibraryActions.updateLibrarySearchType(ConstValues.librarySearchType.browse);
    this._searchTag(event);
    this.props.onClick && this.props.onClick();
  }

  onClickMostCommonlyUsedTag(event) {
    LibraryActions.updateLibrarySearchType(ConstValues.librarySearchType.browse);
    this._searchTag(event);
    this.props.onClick && this.props.onClick();
  }

  onClickLibrary(event) {
    LibraryActions.updateLibrarySearchType(ConstValues.librarySearchType.browse);
    const library = event.target.dataset.library;
    setTimeout(() => LibraryActions.searchLibrary(library), 0);
    this.props.onClick && this.props.onClick();
  }

  handleLibraryClick(libraryId) {
    LibraryCreateActions.editLibrary(libraryId);
  }

  _recentlyUsedTags() {
    const sources = this.props.sources;
    if (!sources) {
      return null;
    }
    const tags = sources.get('recentTags');
    if (!tags) {
      return null;
    }
    return tags;
  }

  _renderRecentlyUsedTags(tags) {
    return (
      <ol>
        {tags.map(tag => {
          const tagDate = new Date(tag.last_updated_at);
          const options = {
            year: '2-digit',
            month: '2-digit',
            day: 'numeric',
          };
          return (
            <li key={tag.id} className="tag">
              <span className="name" onClick={this.onClickRecentlyUsedTag} data-tag={tag.name}>
                {tag.name}
              </span>
              <span className="description">{tagDate.toLocaleDateString('en-US', options)}</span>
            </li>
          );
        })}
      </ol>
    );
  }

  renderRecentlyUsedTagsIfAvailable() {
    const tags = this._recentlyUsedTags();
    if (tags && tags.length > 0) {
      return (
        <div id="most-recently-used-tags" className="subheader">
          <h3>
            <span className="emphasis">Most recently used tags</span>{' '}
            <span className="subheader-text">/ Last Update:</span>
          </h3>
          {this._renderRecentlyUsedTags(tags)}
        </div>
      );
    }
    return null;
  }

  _commonTags() {
    const sources = this.props.sources;
    if (!sources) {
      return null;
    }
    const tags = sources.get('commonTags');
    if (!tags) {
      return null;
    }
    return tags;
  }

  _renderMostCommonTags(tags) {
    return (
      <ol>
        {tags.map(tag => {
          return (
            <li key={tag.id} className="tag">
              <span className="name" onClick={this.onClickMostCommonlyUsedTag} data-tag={tag.name}>
                {tag.name}
              </span>
              <span className="description">{tag.calls_count}</span>
            </li>
          );
        })}
      </ol>
    );
  }

  renderMostCommonTagsIfAvailable() {
    const tags = this._commonTags();
    if (tags && tags.length > 0) {
      return (
        <div id="most-commonly-used-tags" className="subheader">
          <h3>
            <span className="emphasis">Most commonly used tags</span>{' '}
            <span className="subheader-text">/ Calls:</span>
          </h3>
          {this._renderMostCommonTags(tags)}
        </div>
      );
    }
    return null;
  }

  renderLibrariesIfAvailable() {
    const libraries = this._libraries();
    if (libraries && libraries.length > 0) {
      return (
        <div id="libraries-you-subscribed-to" className="subheader">
          <h3>
            <span className="emphasis">Your library subscriptions</span>{' '}
            <span className="subheader-text">/ Calls:</span>
          </h3>
          {this._renderLibraries(libraries)}
        </div>
      );
    }
    return null;
  }

  _libraries() {
    const sources = this.props.sources;
    if (!sources) {
      return null;
    }
    const libraries = sources.get('libraries');
    if (!libraries) {
      return null;
    }
    return libraries;
  }

  _renderLibraries(libraries) {
    return (
      <ol>
        {libraries.map(library => {
          if (library.can_manage) {
            return (
              <li key={library.id} className="library">
                {this.renderLibrary(library)}
                &nbsp;&nbsp;
                <Button
                  size="small"
                  className="manage"
                  onClick={() => this.handleLibraryClick(library.id)}>
                  Manage
                </Button>
              </li>
            );
          } else {
            return (
              <li key={library.id} className="library">
                {this.renderLibrary(library)}
              </li>
            );
          }
        })}
      </ol>
    );
  }

  renderLibrary(library) {
    let libraryName = library.name;
    if (libraryName.length > ConstValues.maxCharsInLibraryName) {
      libraryName = libraryName.substring(0, ConstValues.maxCharsInLibraryName - 3) + ' . . .';
    }
    return (
      <div style={{display: 'inline-block'}}>
        <span className="name" onClick={this.onClickLibrary} data-library={library.id}>
          {libraryName}
        </span>
        &nbsp;
        <div className="description">
          <span>{library.calls_count}</span>
        </div>
      </div>
    );
  }

  searchMostRecentlyAddedCalls() {
    LibraryActions.updateLibrarySearchType(ConstValues.librarySearchType.mostRecentlyAdded);
    setTimeout(() => LibraryActions.searchMostRecentlyAdded(), 0);
    this.props.onClick && this.props.onClick();
  }

  shouldRenderBrowseTab() {
    const libraries = this._libraries();
    const noLibraries = !libraries || libraries.length === 0;
    if (noLibraries) {
      // user has no libraries, so don't render the whole browse section
      return false;
    } else if (libraries && libraries.length > 0) {
      // user has libraries, so don't render the whole browse section iff none of these libraries have any calls in them
      let userHasViewOnlyPermissionToAllLibraries = true;
      let someLibrariesHaveCalls = false;
      libraries.forEach(library => {
        if (library.calls_count > 0) {
          someLibrariesHaveCalls = true;
        }
        library.permissions.forEach(perm => {
          if (perm !== 'view') {
            userHasViewOnlyPermissionToAllLibraries = false;
          }
        });
      });
      if (userHasViewOnlyPermissionToAllLibraries) {
        return someLibrariesHaveCalls;
      } else {
        let userHasAdminOrCreateTagsPermissionToSomeLibraries = false;
        libraries.forEach(library => {
          library.permissions.forEach(perm => {
            if (perm === 'admin' || perm === 'create_tags') {
              userHasAdminOrCreateTagsPermissionToSomeLibraries = true;
            }
          });
        });
        return userHasAdminOrCreateTagsPermissionToSomeLibraries;
      }
    }
    return true;
  }

  librariesHaveCalls() {
    const libraries = this._libraries();
    let librariesHaveCalls = false;
    libraries.forEach(library => {
      if (library.calls_count > 0) {
        librariesHaveCalls = true;
      }
    });
    return librariesHaveCalls;
  }

  renderSearchMostRecentlyAddedCallsIfAvailable() {
    if (this.librariesHaveCalls()) {
      return (
        <div className="pane-note">
          <span onClick={this.searchMostRecentlyAddedCalls}>View Most Recently Added Calls</span>
        </div>
      );
    }
  }

  getDialogProps = () => {
    return {
      createForm: this.props.LibraryCreateFormStore,
      formState: this.props.LibraryStore.get('formState'),
      shareAccessible: this.props.LibraryStore.get('shareAccessible'),
      adminManage: false,
      sources: this.props.LibraryStore.get('sources'),
      user: this.props.AuthStore.user,
    };
  };

  render() {
    if (this.shouldRenderBrowseTab()) {
      return (
        <Card className="browse plain-border">
          <div className="pane">
            <h2>Browse Library</h2>
            {this.renderSearchMostRecentlyAddedCallsIfAvailable()}
          </div>

          <div className="browse-subheaders">
            {this.renderRecentlyUsedTagsIfAvailable()}
            {this.renderMostCommonTagsIfAvailable()}
            {this.renderLibrariesIfAvailable()}
          </div>

          <LibraryCreateDialog {...this.getDialogProps()} />
        </Card>
      );
    } else {
      // It must be here to be always able create library even if no browse tab shown
      // TODO: most probably must be moved to LibraryCreateTab.js
      return (
        <div>
          <LibraryCreateDialog {...this.getDialogProps()} />
        </div>
      );
    }
  }
}
